/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, Component, Inject, Input,
} from '@angular/core';
import { DialogService } from '@ng-falcon/dialog/dialog.service';
import { FlagService } from '../../../../services/flag.service';
import { ActionState } from './pending';
import { ReportDialogComponent } from './report-dialog.component';

// One-way "Report" for a feed card (COMMUNITY_ANIMATIONS.html option 4C, kept button-shaped).
@Component({
  selector: 'ut-community-report-action',
  templateUrl: './community-report-action.component.html',
  styleUrls: ['./action-button.scss', './community-report-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CommunityReportActionComponent {
  @Input({ required: true }) item: any;

  readonly state = new ActionState();

  constructor(
    @Inject('AlertService') private AlertService: any,
    @Inject('LightTesterErrorService') private LightTesterErrorService: any,
    @Inject('$analytics') private $analytics: any,
    private flagService: FlagService,
    private dialogService: DialogService,
  ) {}

  get reported(): boolean {
    return this.item.flagged_by_current_user === true;
  }

  report(): void {
    if (this.reported || this.state.busy() || this.LightTesterErrorService.show()) return;
    this.dialogService.open(ReportDialogComponent).afterClosed().subscribe((reason?: string) => {
      if (!reason) return;
      this.state.run(this.flagService.flag(this.item.type, this.item.id, reason)).then(() => {
        this.item.flagged_by_current_user = true;
        this.$analytics.eventTrack('Flagged', { category: 'Flag', label: this.item.type });
        this.state.complete('on', 'Reported. A moderator will review this post.');
      }, () => this.AlertService.addDanger('There was an error submitting your report'));
    });
  }
}
